<template>
  <div class="contenedor-cpanel">
    <!-- <Header2/> -->
    <section class="contenedor-c">
      <div class="contenedor-titulo">
        <h1>Listado de Ventas No Entregadas</h1>
        <div class="barra"></div>
      </div>
      <VentasListaCarritoNoEntregadas
      ></VentasListaCarritoNoEntregadas>
    </section>
  </div>
</template>

<script>
import VentasListaCarritoNoEntregadas from '../components/VentasListaCarritoNoEntregadas.vue'
// import Header2 from '../components/Header2.vue'
export default {
  name: 'ListarVentasNoEntregadas',
  components: {
    VentasListaCarritoNoEntregadas
    // Header2
  },
  data: function () {
    return {
    }
  }
}
</script>

<style>

</style>
